import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function PrimaryButton({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <button className={`bg-[#008696] hover:bg-[#006D78] text-white rounded-lg px-4 py-2.5 font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center ${className}`} {...props} data-id="element-372">
      {children}
    </button>;
}
// Keep old names as aliases for backward compat during transition
export const PrimaryButtonPurple = PrimaryButton;
export const PrimaryButtonGreen = PrimaryButton;
export const PrimaryButtonTeal = PrimaryButton;
export function SecondaryButtonOutline({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <button className={`border border-[#D9D9D9] text-[#111111] hover:bg-[#EAF6F7] bg-white rounded-lg px-4 py-2.5 font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center ${className}`} {...props} data-id="element-373">
      {children}
    </button>;
}